import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline-color: grey;
}

/* Defining the size of fonts in the app */
@media(max-width: 1080px) {
  html {
    font-size: 93.75%;
  }
}

@media(max-width: 720px) {
  html {
    font-size: 87.5%;
  }
}

body, input, textarea, button  {
  font: 400 16px "Poppins", sans-serif;
}

button {
  cursor: pointer;
}

a {
  color: inherit;
  text-decoration: none;
}

  @media print {
    body * {
      visibility: hidden;
    }

    #report-content,
    #report-content * {
      visibility: visible;
    }

    @page {
      margin: 0;
    }
  }

`;
